<template>
    <section class="font-poppins">
        <div class="text-white p-2">
            <div class="flex justify-between pt-2">
                <p class="text-sm">Current Balance</p>
                <div class="relative">   
                    <i @click="toggleList" class="fa fa fa-ellipsis-v relative"></i>
                    <div v-show="showHistory" class="absolute right-0">
                        <p class="text-xs bg-white text-blue-700 w-40 p-1"><router-link to="/transaction-history">Transaction History</router-link></p>
                    </div>
                </div>
            </div>
            <div class="text-4xl font-semibold pt-3 pb-5">
                <p>NGN</p>
                <p>{{this.$store.state.accountBalance}}</p>
            </div>
            
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../../Config';
const url = baseUrl;
export default {
    data() {
        return {
            showHistory: null,
            userId : localStorage.getItem('userId'),
            token : localStorage.getItem('token'),
           accountBalance: ""
        }
    },

    mounted() {
        this.walletBalance()
    },

    methods: {
        toggleList() {
            this.showHistory = !this.showHistory
        },

        walletBalance() {
            axios({
               method: 'GET',
                url: `${url}/v1/web/users/wallet/${this.userId}`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((res) => {
                let balance = res.data.data.balance;
                this.accountBalance = balance.toLocaleString();
                this.$store.commit("accountBalance", this.accountBalance);
                
            })
            .catch((err) => {
                err.json
            })
        }
    }
}
</script>